<template>
  <div v-if="embedded" class="col-12 refine-search-filter-embedded">
    <p v-if="!hasSelectedMakes" class="text-grey-7 q-mb-md">Select at least one make to choose models.</p>
    <RefineSearchMultiSelect
      v-else
      class="q-mb-sm"
      v-for="(makeModel, index) in filteredMakeModels"
      :key="index"
      :label="makeModel.make"
      :options="makeModel.models"
      v-model="localSelectedModel[makeModel.make]"
      @model-updated="handleModelUpdated"
      :disabled="disabled || isFetchRatebookLoading"
    />
  </div>
  <CustomExpansionItem v-else class="col-12 q-mb-sm" label="Model" v-model="isOpen" :disabled="!hasSelectedMakes">
    <RefineSearchMultiSelect
      class="q-mb-sm"
      v-for="(makeModel, index) in filteredMakeModels"
      :key="index"
      :label="makeModel.make"
      :options="makeModel.models"
      v-model="localSelectedModel[makeModel.make]"
      @model-updated="handleModelUpdated"
      :disabled="disabled || isFetchRatebookLoading"
    />
  </CustomExpansionItem>
</template>

<script>
import CustomExpansionItem from '../CustomExpansionItem';
import RefineSearchMultiSelect from './RefineSearchMultiSelect';

export default {
  name: 'ModelFilterSection',
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    filteredMakeModels: {
      type: Array,
      default: () => []
    },
    selectedMakes: {
      type: Object,
      default: () => ({})
    },
    disabled: {
      type: Boolean,
      default: false
    },
    isFetchRatebookLoading: {
      type: Boolean,
      default: false
    },
    embedded: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isOpen: false,
      localSelectedModel: { ...this.value },
      isSyncingFromProp: false
    };
  },
  computed: {
    hasSelectedMakes() {
      return Object.keys(this.selectedMakes).some((make) => this.selectedMakes[make]);
    }
  },
  watch: {
    value: {
      handler(newValue) {
        // Prevent circular updates - only sync if different
        if (!this.isSyncingFromProp) {
          this.isSyncingFromProp = true;
          // Deep clone to ensure reactivity
          this.localSelectedModel = JSON.parse(JSON.stringify(newValue || {}));
          this.$nextTick(() => {
            this.isSyncingFromProp = false;
          });
        }
      },
      deep: true
    },
    // Watch filteredMakeModels to ensure we sync when makes/models become available
    filteredMakeModels: {
      handler() {
        // When filteredMakeModels updates (e.g., vehicleSearchConfig loads), sync the value prop
        if (this.value && Object.keys(this.value).length > 0 && !this.isSyncingFromProp) {
          this.isSyncingFromProp = true;
          this.localSelectedModel = JSON.parse(JSON.stringify(this.value || {}));
          this.$nextTick(() => {
            this.isSyncingFromProp = false;
          });
        }
      },
      immediate: false
    },
    localSelectedModel: {
      handler(newValue) {
        // Only emit if change came from user interaction, not prop sync
        if (!this.isSyncingFromProp) {
          this.$emit('input', newValue);
          this.$emit('change');
        }
      },
      deep: true
    }
  },
  methods: {
    handleModelUpdated() {
      this.$emit('model-updated');
      this.$emit('change');
    }
  },
  components: {
    CustomExpansionItem,
    RefineSearchMultiSelect
  }
};
</script>
